import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import presentacionDfVideo from "../assets/avatares/presentacion-fepol.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";
import "./StartGame.css";

function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const { videoRef } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	const handleStartGame = (e) => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);

		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME2, {
					state: {
						activeScenario: 1,
					},
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<div className="start-game-page start-game-page--welcome">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Fepol
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={presentacionDfVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>
					<div className="start-game-panel">
						<h1 className="start-game-title">
							Inicio de la {" "}
							<span className="start-game-title-accent">
								Simulación
							</span>
						</h1>
						<p className="start-game-lead">
							En esta dinámica, participarás en una simulación formativa basada en una situación realista del trabajo policial en la calle.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							Tendrás que analizar la información disponible, valorar los riesgos y tomar decisiones paso a paso, como ocurriría en una intervención real.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							El objetivo es entrenar la toma de decisiones, la comunicación, la priorización de actuaciones y la aplicación de criterios profesionales con seguridad, proporcionalidad y responsabilidad.
						</p>
						<div className="start-game-footer">
							<button
								type="button"
								className="start-game-cta"
								onClick={handleStartGame}
								disabled={loading}
								aria-busy={loading}
							>
								{loading ? (
									<span
										className="start-game-cta-spinner"
										aria-hidden
									/>
								) : (
									<img
										className="start-game-cta-icon"
										src={flechaAvanzar}
										alt=""
									/>
								)}
								{loading ? "Cargando…" : "Continuar"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GameIntroduction;
